<template>

  <el-dialog
    class="loading-dialog"
    :center="true"
    title=""
    :visible.sync="dialogVisible"
    width="450px">
    <div class="text-center">
      <br>
      <img class="loading-style" src="@/assets/icon/loading.png"/>
      <br>
      <span>
        loading...
      </span>
      <br>
      <br>
    </div>
  </el-dialog>

</template>

<script>
export default {
  name: "LoadingDialog",
  props: {
    dialogVisible: Boolean
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
.loading-dialog {
  ::v-deep .el-dialog__header{
    display: none;
  }
}
.loading-style {
  width: 32px;
  height: auto;
  animation: rotating 2s linear infinite;
}
</style>
